declare namespace $ {

	export class $shm_hitalama_map_page_arrow_widgets extends $shm_hitalama_map_page_arrow {
		from_pos( ): readonly(number)[]
		to_pos( ): readonly(number)[]
		from_widget( ): $shm_hitalama_map_widget_float
		to_widget( ): $shm_hitalama_map_widget_float
		from( ): ReturnType< $shm_hitalama_map_page_arrow_widgets['from_pos'] >
		to( ): ReturnType< $shm_hitalama_map_page_arrow_widgets['to_pos'] >
	}
	
}

//# sourceMappingURL=widgets.view.tree.d.ts.map